<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>
  html {
    position:relative;
    min-height: 100%;
    width: 100%;
    /*padding-bottom: 108px;*/caret-color:transparent;
  }

  body {
    margin: 0;
    min-width: 1366px;
    height: 100%;
    background-color: #F2F2F2
  }
</style>



// WEBPACK FOOTER //
// src/App.vue